import React, { useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Box } from "@mui/system";
import { Heading } from "../../components/styledConstants";
import Tabs from "../../components/ManageDistributor/Tabs";
import {
  PartnerDashboard,
  BasicDetailsForm,
  Users,
  Transactions,
  OrgWalletLedger,
  AccountDetails,
} from "../../features/organizationHub/societyHub";

const tabData = [
  {
    active: false,
    name: "DASHBOARD",
    id: "dashboard",
  },
  {
    active: false,
    name: "BASIC DETAILS",
    id: "basic",
  },
  {
    active: false,
    name: "USERS",
    id: "users",
  },
  {
    active: false,
    name: "SETTLEMENTS",
    id: "settlements",
  },
  { active: false, name: "WALLET DETAILS", id: "wallet_ledger" },
  { active: false, name: "ACCOUNT DETAILS", id: "acc_details" },
];
const SocietyDashboard = () => {
  const { societyName } = useParams();
  const location = useLocation();
  const society = location.state?.society;
  const [activeTab, setActiveTab] = useState("dashboard");
  if (!society) {
    return <div>Loading or no society data found...</div>;
  }
  return (
    <>
      <div className="flex flex-center space-between mb10">
        <Heading size="xxl">{societyName}</Heading>
      </div>
      <Box mt={1}>
        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} tabData={tabData} />
        <div>
          {activeTab === "dashboard" && <PartnerDashboard orgUserId={society.orgUserId} />}
          {activeTab === "basic" && <BasicDetailsForm society={society} />}
          {activeTab === "users" && <Users userid={society.orgUserDetailId} />}
          {activeTab === "settlements" && <Transactions orgUserDetailId={society.orgUserDetailId} />}
          {activeTab === "wallet_ledger" && <OrgWalletLedger userId={society.orgUserId} />}
          {activeTab === "acc_details" && <AccountDetails user={society} />}
        </div>
      </Box>
    </>
  );
};

export default SocietyDashboard;
